import { flareUiPlugin as e } from "./flare-ui-plugin.js";
const t = {
  content: [],
  plugins: [e]
};
export {
  t as flareUiPreset
};
